import { render, staticRenderFns } from "./SalesCostDetail.vue?vue&type=template&id=0bf7e5e8&scoped=true"
import script from "./SalesCostDetail.vue?vue&type=script&lang=js"
export * from "./SalesCostDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesCostDetail.vue?vue&type=style&index=0&id=0bf7e5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7e5e8",
  null
  
)

export default component.exports